import React from "react";
import ProjectContentBox from "./ProjectContentBox";

export default function Projects() {
  const otherProjects = [
    {
      id: 0,
      title: "Location Optimization for supermarkets",
      projectURL:
        "https://docs.google.com/presentation/d/18wD7E6FC9HX7jLO18fqhRYD8Vf4fMr1U/edit#slide=id.p1",
      githubURL: "https://github.com/JohnnyTung123/DataHack_cuhkGPT",
      description: [
        "Champion in CUHK Data Hack, 2023",
        "Found 3 factors and developed a multivariate regression model for sales volume prediction, which identified Sham Shui Po as the most optimal location",
        "Cleaned and prepared data for 18 districts and Wellcome supermarkets, combining demographics, income, and competition information for location analysis.",
      ],
      thumbnail: "/images/cuhk-gpt.png",
    },
    // {
    //   id: 1,
    //   title: "DeFi Research",
    //   projectURL: "",
    //   githubURL:
    //     "https://github.com/JohnnyTung123/defi-research/blob/main/DeFi%20Research.pdf",
    //   description: [
    //     "Built a multivariate regression model using on-chain data (BTC/ETH volatility, trading pair counts) to predict Uniswap v2 pool growth.",
    //     "Created and tested multiple regression models, selecting key predictors (e.g., USDT pairs, DAI pairs, WETH pairs) based on statistical significance and minimizing cross-validation error (MAE).",
    //     "Profiled high-frequency trading wallet 0xd4bC…e80E3 by analyzing 10,000+ transactions with Etherscan API, identifying bot-like behavior, large token holdings (~$3.5M), and liquidity provisioning patterns.",
    //   ],
    //   thumbnail: "/images/etherscan.png",
    // },
    {
      id: 2,
      title: "Talent Quest 2K23",
      projectURL: "https://www.hkstp.edu.careerhackers.io/play",
      // githubURL: "https://github.com/lovelycutepanda/csci2720-project",
      description: [
        "Developed the frontend for a Three.js web puzzle game with Vue, Vuex, TypeScript and AWS - 110,000+ visits and 2000+ sign-ups",
        "Collaborated and maintained with five developers via GitOps workflow",
        "Focused greatly on structuring the client and server-side communications to prevent gameplay exploits",
      ],
      thumbnail: "/images/2k23.png",
    },
    // {
    //   id: 3,
    //   title: "Medical Healthcare Dapp",
    //   projectURL: "https://medical-healthcare-dapp-1030.vercel.app/",
    //   githubURL: "https://github.com/JohnnyTung123/Medical-Healthcare-Dapp",
    //   description: [
    //     "Healthcare Dapp for storing medical records",
    //     "Deployed a smart contract using Solidity, Truffle, and MetaMask",
    //     "Developed a registration and login system for doctors and patients, connected to a MongoDB database.",
    //   ],
    //   thumbnail: "/images/medicare.png",
    // },
    // {
    //   id: 4,
    //   title: "TrimHub",
    //   projectURL: "",
    //   githubURL: "https://github.com/JohnnyTung123/TrimHub",
    //   description: [
    //     "Web-based application for searching and booking barbershop services",
    //     "Allows online payments for haircut services",
    //     "Users can leave reviews and opinions about salons",
    //     "Salons can promote their business with profiles, photos, and videos",
    //   ],
    //   thumbnail: "/images/trimhub.png",
    // },
    {
      id: 5,
      title: "Metaverse",
      projectURL: "https://testing-experience.careerhackers.io/",
      githubURL: "",
      description: [
        "Led a tech team of 6 to develop a metaverse for career simulation, responsible for UI/UX design, frontend implementation, and databases supporting 50+ simultaneous participants.",
        "Implemented a real-time chat system using Socket.io and WebRTC, enabling seamless communication between users.",
      ],
      thumbnail: "/images/metaverse.png",
    },
  ];

  return (
    <>
      <div id="skills-container" className="p-4 md:ml-12 pb-2">
        <h4 className="text-md md:text-xl tracking-[4px] underline underline-offset-4 font-semibold mb-10">
          Other Projects
        </h4>
        <div className="flex flex-row-reverse justify-center md:justify-end h-fit relative">
          <ol className="w-full relative max-w-7xl">
            {otherProjects.map((project) => (
              <ProjectContentBox key={project.id} content={project} />
            ))}
          </ol>
        </div>
      </div>
    </>
  );
}
